import Structure, { StructureECommerce } from "../../common/components/builder/Structure.js";

import * as API from "./api.js";

export async function AiGenerateECommerce(idProject) {
    const response = await API.ProjectAiEcommerce(idProject);
    return await process(response, "ecommerce");
}

export async function AiGeneratePage(idProject) {
    const response = await API.ProjectAiPage(idProject);
    return await process(response, "page");
}

async function process(response, type) {
    if (!response?.ok || response?.errors) {
        return response;
    }

    const aiVariables = {};

    for (const fieldName in response?.fields) {
        aiVariables[fieldName] = response.fields[fieldName];
    }

    if (aiVariables?.Color) {
        // let { primary, secondary } = aiVariables.Color;
        // primary.length === 6 && (primary = `#${primary}`);
        // secondary.length === 6 && (secondary = `#${secondary}`);
        // aiVariables.color = { primary, secondary };
        delete aiVariables.Color;
    }

    const aiStructure = [type === "ecommerce" ? StructureECommerce() : Structure()];

    // ! WAT? =(((
    // aiStructure[0].structureVirgin = aiStructure[0].children;

    return { aiVariables, aiStructure };
}
